import { Component, HostListener, inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule, Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { WaiterService } from '../../_service/waiter.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cart',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.scss'
})
export class CartComponent implements OnInit {
  @Input() orderId: any;
  showScroll: boolean = false;
  showPopup: boolean = false;
  cartItems: any[] = [];
  private modalService = inject(NgbModal);
  service = inject(WaiterService)
  router = inject(Router)
  constructor(config: NgbModalConfig) {
    config.centered = true;
  }
  ngOnInit(): void {
    this.loadCartItems();
  }

  // Fetch cart items from localStorage
  loadCartItems() {
    const cart = localStorage.getItem('cart');
    if (cart) {
      this.cartItems = JSON.parse(cart);
    } else {
      this.cartItems = [];
    }
  }

  // Increment quantity for a specific cart item
  increment(item: any) {
    item.quantity += 1;
    this.updateCart();
  }

  // Decrement quantity for a specific cart item
  decrement(item: any) {
    if (item.quantity > 1) {
      item.quantity -= 1;
      this.updateCart();
    } else {
      // Remove item if quantity reaches 0
      this.removeItem(item);
    }
  }

  // Update cart in localStorage
  updateCart() {
    localStorage.setItem('cart', JSON.stringify(this.cartItems));
  }

  // Remove an item from the cart
  removeItem(item: any) {
    this.cartItems = this.cartItems.filter(cartItem => cartItem.id !== item.id);
    this.updateCart();
    this.showPopup = false;
  }
  // Calculate the total amount for the cart
  getTotalAmount(): number {
    return this.cartItems.reduce((total, item) => total + (item.selling_price * item.quantity), 0);
  }

  open(content: any) {
    this.modalService.open(content);
  }

  closePopup() {
    this.showPopup = false;
  }

  onCardScroll(card: HTMLElement) {
    this.showScroll = card.scrollTop > 100;
  }

  scrollToTop(card: HTMLElement) {
    card.scrollTo({ top: 0, behavior: 'smooth' });
  }

  AddToOrder() {
    let a: any;
    let data;
    let b = []
    for (let i = 0; i < this.cartItems.length; i++) {
      const element = this.cartItems[i];
      a = { quantity: element.quantity, inventory_id: element.id }
      b.push(a)

    }
    data = {
      order_items: [...b]
    }


    this.service.addItems(data, this.orderId).subscribe({
      next: (res) => {
        Swal.fire('Success', '', 'success')
      },
      error: (err) => {
        Swal.fire('Failed', err.error.message, 'error')
      },
      complete: () => {
        this.modalService.dismissAll()
        this.router.navigateByUrl(`/orders/${this.orderId}`)
        localStorage.removeItem('cart')
      }
    })
  }
}
